import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal, { Eyebrow } from "./Reveal";
import { CONTACT } from "../data/content";
import { useLang } from "../i18n/LanguageContext";

export default function CtaBand() {
  const { t } = useLang();
  return (
    <section className="navy-texture text-white" data-testid="cta-band">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28 text-center">
        <Reveal>
          <Eyebrow dark>{t.cta.eyebrow}</Eyebrow>
          <h2 className="mt-6 font-serif-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight max-w-3xl mx-auto text-balance">
            {t.cta.title}
          </h2>
          <p className="mt-6 text-slate-300 max-w-2xl mx-auto">{t.cta.text}</p>
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/contact"
              data-testid="cta-contact-button"
              className="inline-flex items-center gap-2 bg-[#C9A15A] text-white hover:bg-[#B38C48] transition-colors duration-300 px-8 py-3.5 text-sm font-medium rounded-sm"
            >
              {t.cta.contactBtn}
              <ArrowRight className="h-4 w-4" />
            </Link>
            <a
              href={`tel:${CONTACT.phoneHref}`}
              data-testid="cta-phone-button"
              className="inline-flex items-center gap-2 border border-white/40 text-white hover:bg-white hover:text-[#1B3A5B] transition-colors duration-300 px-8 py-3.5 text-sm font-medium rounded-sm"
            >
              {CONTACT.phone}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
